import { post, put, get, del } from '../utils/api-utils';
import Axios from 'axios';
import getFromLodash from 'lodash/get';
import { baseUrl } from 'gatsby-env-variables';
export const getOtp = values =>
  post('partner/register/', {
    name: {
      firstName: values.firstName,
      lastName: values.lastName
    },
    email: values.email,
    password: values.password,
    phone: values.mobile,
    invitationId: values.invitationId,
    hashValue: values.hashValue,
    expiryTime: values.expiryTime
  }).then(({ data }) => data);

export const resendOtp = (values, type) => {
  return put('partner/register/resend-otp?type=' + type, {
    phone: values.phone,
    email: values.email
  }).then(({ data }) => data);
};

export const confirmOtp = values =>
  post(
    'partner/register/confirm-otp/',
    {
      phone: values.phone,
      phoneOtp: values.mobileOtp,
      email: values.email,
      emailOtp: values.emailOtp
    },
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization'
    }
  ).then(({ data }) => data);

export const createPassword = (body, token) => {
  return put(
    'users/password/',
    body,
    { token },
    {
      'Content-Type': 'text/plain'
    }
  ).then(({ data }) => data);
};
export const getKycStatus = () => {
  return get('partner/kyc/status').then(({ data }) => {
    return data;
  });
};

export const customerDetails = body =>
  post(
    'lead',
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization'
    }
  ).then(({ data }) => data);

// get customerdetail based on leadId

export const getCustomerDetails = leadId =>
  get(`lead/${leadId}`).then(({ data }) => data);

//update lead status

export const updateCustomerDetails = (leadId, body) =>
  put(
    `lead/${leadId}`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization'
    }
  ).then(({ data }) => data);

export const getLoanProduct = () =>
  get(`master/loans/product`).then(({ data }) => {
    return data;
  });
// create Lead Applicant
export const createApplicant = (body, leadId) =>
  post(
    `lead/${leadId}/applicant`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization'
    }
  ).then(({ data }) => data);

export const basicDetails = body =>
  put(
    'partner/profile/',
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization'
    }
  ).then(({ data }) => data);

//  getting basic details from the server using partner id
export const getBasicDetails = () =>
  get('partner/profile').then(({ data }) => data);

export const login = ({ username, userType, password }) =>
  post(
    'users/login/',
    {
      username,
      userType,
      password
    },
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization'
    }
  ).then(({ data }) => data);

export const getPresignedUrl = body =>
  post('partner/kyc/upload-url', body, {}, {}).then(({ data }) => data);

export const fileUploadApi = (url, body) =>
  put(
    url,
    body,
    {},
    {
      'Content-Type': false
    }
  ).then(({ data }) => data);

export const getOcrData = body =>
  post('partner/kyc/ocr-data', body).then(({ data }) => data);

export const getLpgInfo = body => {
  return post('kyc/address-proof/lpg', body)
    .then(({ data }) => data)
    .catch(err => {
      return {
        isAxiosError: true,
        data: getFromLodash(err, 'response.data', {})
      };
    });
};
export const getPngInfo = body => {
  return post('kyc/address-proof/png', body)
    .then(({ data }) => data)
    .catch(err => {
      return {
        isAxiosError: true,
        data: getFromLodash(err, 'response.data', {})
      };
    });
};

export const submitreference = body =>
  post(
    'partner/references/',
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const getchequeOcr = body =>
  post(
    'kyc/cheque/ocr-data',
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const ForgotPassword = body =>
  post('users/password/forgot', body).then(({ data }) => data);

export const ConfirmOTPForgotPassword = data =>
  post('users/password/confirm-otp', data).then(({ data }) => data);
export const getPinCodeInfo = pincode => {
  return Axios.get(`https://api.postalpincode.in/pincode/${pincode}`)
    .then(({ data }) => ({
      isAxiosError: false,
      data
    }))
    .catch(err => {
      return {
        isAxiosError: true,
        data: getFromLodash(err, 'response.data', {})
      };
    });
};
export const UpdatePasswordAPI = body =>
  put(
    'users/password/change/',
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const UpdateKYCstepAPI = body =>
  put(
    'partner/kyc/uploaded-doc/',
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);
//property details api call
// http://api-dev.fincity.in/master/loans/product?productId=1

export const getPropertyDetailsApi = (productId = 1) =>
  get(`master/loans/product?productId=${productId}`).then(({ data }) => data);

export const submitPropertyLocationAPI = (LeadId, body) =>
  put(
    'lead/' + LeadId + '/address/',
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const GetKhataList = pin_code =>
  get('master/propertyTitles?pincode=' + pin_code).then(({ data }) => data);

export const setPropertyTitle = (LeadID, body) =>
  put(
    'lead/' + LeadID + '/propertytitle',
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const setLoanProducts = (LeadID, body) =>
  put(
    'lead/' + LeadID + '/loanproducts',
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const getPBTableDataRM = (
  page,
  size,
  fromDate,
  todate,
  sort,
  sortDir,
  status,
  rmId = '',
  bpUserId = '',
  targetMonth = '',
  productId,
  bankId,
  cityId,
  disbursedMonth = '',
  source = '',
  serachPara = ''
) =>
  get(
    `dashboard/customer?from=${fromDate}&to=${todate}&page=${page}${size &&
      `&size=${size}`}${sort && `&sort=${sort}`},${sortDir}${
      status && status != 'ALL' ? '&status=' + status : ''
    }${rmId && `&rmUserId=${rmId}`}${bpUserId && `&bpUserId=${bpUserId}`}${
      targetMonth ? `&targetMonth=${targetMonth}` : ''
    }${productId && `&productId=${productId}`}${
      bankId ? `&bankId=${bankId}` : ''
    }${cityId ? `&bankCityId=${cityId}` : ''}${
      disbursedMonth
        ? `&disbursedMonth=${`${disbursedMonth?.year}-${
            disbursedMonth?.month
          }-${28}`}`
        : ''
    }${source ? `&leadSourceId=${source}` : ''}${serachPara &&
      `&searchby=${serachPara}`}`
  ).then(({ data }) => {
    return {
      data: data._embedded ? data._embedded.customers : [],
      dataPage: data.page
    };
  });

export const getPBTableDataBP = (
  page,
  size,
  fromDate,
  todate,
  sort,
  sortDir,
  status
) =>
  get(
    'dashboard/customer?from=' +
      fromDate +
      '&to=' +
      todate +
      '&page=' +
      page +
      '&size=' +
      size +
      '&sort=' +
      sort +
      ',' +
      sortDir +
      (status && status != 'ALL' ? '&status=' + status : '')
  ).then(({ data }) => {
    return {
      data: data._embedded ? data._embedded.customers : [],
      dataPage: data.page
    };
  });
export const serachCustomer = (size, fromDate, todate, searchby, rmId) =>
  get(
    'dashboard/customer?from=' +
      fromDate +
      '&to=' +
      todate +
      '&size=' +
      size +
      '&rmUserId=' +
      rmId +
      '&searchby=' +
      searchby
  ).then(({ data }) => {
    return {
      data: data._embedded ? data._embedded.customers : [],
      dataPage: data.page
    };
  });
export const getCallDetails = (
  page,
  size,
  fromDate,
  todate,
  sort,
  sortDir,
  rmId = '',
  callsBy = 'direct'
) =>
  get(
    'dashboard/employee/callDetails?from=' +
      fromDate +
      '&to=' +
      todate +
      '&page=' +
      page +
      '&sort=' +
      sort +
      ',' +
      sortDir +
      '&size=' +
      size +
      '&callsBy=' +
      callsBy +
      '&rmUserId=' +
      rmId
  ).then(({ data }) => {
    if (Array.isArray(data._embedded.tupleBackedMapList)) {
      data._embedded.tupleBackedMapList.map((each, index) => {
        each['serial_number'] = parseInt(page) + index + 1;
      });
    }
    return {
      data: data._embedded.tupleBackedMapList
        ? data._embedded.tupleBackedMapList
        : [],
      dataPage: data.page
    };
  });

export const getCallSummary = (fromDate, todate, rmId, callsBy) =>
  get(
    'dashboard/employee/callDetails/summary?from=' +
      fromDate +
      '&to=' +
      todate +
      '&rmUserId=' +
      rmId +
      '&callsBy=' +
      callsBy
  ).then(({ data }) => data);

//api for BP cards
//GET /dashboard/cards?from=yyyy-mm-dd&to=yyyy-mm-dd&status=Rejected
//http://api-dev.fincity.in/dashboard/card?from=2020-05-05&to=2020-05-08
export const getBPCardsData = (startdate, enddate, status, targetMonth = '') =>
  get(
    `dashboard/card?from=${startdate}&to=${enddate}${
      status ? `&status=${status}` : ``
    }&targetMonth=${targetMonth}`
  ).then(({ data }) => data);

export const GetLeadStatus = () => get('lead/status').then(({ data }) => data);

export const getListPartner = (
  page,
  size,
  fromDate,
  todate,
  sort,
  sortDir,
  rmId = ''
) =>
  get(
    'dashboard/employee/bp/list?from=' +
      fromDate +
      '&to=' +
      todate +
      '&page=' +
      page +
      '&size=' +
      size +
      '&sort=' +
      sort +
      ',' +
      sortDir +
      '&rmUserId=' +
      rmId
  ).then(res => {
    return {
      data: res.data._embedded
        ? res.data._embedded.bpList
          ? res.data._embedded.bpList
          : []
        : [],
      dataPage: res.data.page
    };
  });
export const serachBP = (size, fromDate, todate, searchby, rmId = '') =>
  get(
    'dashboard/employee/bp/list?from=' +
      fromDate +
      '&to=' +
      todate +
      '&size=' +
      size +
      '&rmUserId=' +
      rmId +
      '&searchby=' +
      searchby
  ).then(({ data }) => {
    return {
      data: data._embedded ? data._embedded.bpList : [],
      dataPage: data.page
    };
  });
export const GetAllRmList = () => get('employees/rm').then(({ data }) => data);

export const getUserProfile = () =>
  get('users/profile').then(({ data }) => data);
//rm can add BP
///employees/bp/invite
export const getAddBPApi = values =>
  post('employees/bp/invite/', {
    name: {
      firstName: values.firstName,
      lastName: values.lastName
    },
    email: values.email,
    mobile: values.mobile
  })
    .then(({ data }) => data)
    .catch(err => {
      return {
        isAxiosError: true,
        data: getFromLodash(err, 'response.data.message', {})
      };
    });
export const updatePriority = (LeadID, body) =>
  put(
    'lead/' + LeadID + '/priority',
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

//api call for admin card
//http://api-dev.fincity.in/dashboard/employee/bpCount?from=2020-5-01&to=2020-5-21
export const getAdminCardsData = (startdate, enddate) =>
  get(`dashboard/employee/bpCount?from=${startdate}&to=${enddate}`).then(
    ({ data }) => data
  );

export const getAclForUser = () => get(`users/acl`).then(({ data }) => data);

export const AssignRmToBP = (rm, bp) =>
  put(
    'employees/bp/assignRm',
    {
      bpId: bp,
      rmId: rm
    },
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const UserKycUpload = (file, leadId, applicantId, doc, tag = '') =>
  post(
    `lead/${leadId}/kyc/${doc}/${applicantId}/upload/${tag}`,
    file,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const UserKycOcr = (leadId, applicantId, docId, doc) =>
  put(`lead/${leadId}/kyc/${doc}/${applicantId}/${docId}`).then(
    ({ data }) => data
  );
export const isDlUploaded = (leadId, applicantId, docId) =>
  put(`lead/${leadId}/kyc/dl/${applicantId}/${docId}/uploaded`).then(
    ({ data }) => data
  );
export const isPan = (leadId, applicantId, docId, doc) =>
  put(`lead/${leadId}/kyc/${doc}/${applicantId}/${docId}`).then(
    ({ data }) => data
  );

export const UploadFileToS3 = (url, file) =>
  Axios.put(url, file).then(({ data }) => data);

export const UserKycSave = (leadId, applicantId, body, doc) =>
  put(
    `lead/${leadId}/kyc/${doc}/${applicantId}/save`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);
export const UserKycVarifyDetails = (leadId, applicantId, body, doc) =>
  put(
    `lead/${leadId}/kyc/${doc}/${applicantId}/verify`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);
///lead/{lead-id}/kyc/address/{applicant-id}/hrletter/save
export const SaveAddressProof = (leadId, applicantId, doc, body) =>
  put(
    `lead/${leadId}/kyc/address/${applicantId}/${doc}/save`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  )
    .then(({ data }) => {
      return data;
    })
    .catch(err => {
      return {
        isAxiosError: true,
        error: err.response
      };
    });
//upload Hr letter
///lead/{lead-id}/kyc/address/{applicant-id}/hrletter/upload
export const UserKycAddressProofUpload = (file, leadId, applicantId, doc) =>
  post(
    `lead/${leadId}/kyc/address/${applicantId}/${doc}/upload`,
    file,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  )
    .then(({ data }) => {
      return data;
    })
    .catch(err => {
      return {
        isAxiosError: true,
        error: err.response
      };
    });

////lead/{lead-id}/kyc/address/{applicant-id}/{doc-id}/hrletter/uploaded
export const UserKycAddressProofUploaded = (leadId, applicantId, docId, doc) =>
  put(
    `lead/${leadId}/kyc/address/${applicantId}/${docId}/${doc}/uploaded`,
    {},
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  )
    .then(({ data }) => {
      return data;
    })
    .catch(err => {
      return {
        isAxiosError: true,
        error: err.response
      };
    });

//get api for pan
export const getApiPan = (leadId, applicantId) =>
  get(`lead/${leadId}/kyc/pan/${applicantId}`).then(({ data }) => data);

export const getApiDl = (leadId, applicantId) =>
  get(`lead/${leadId}/kyc/dl/${applicantId}`).then(({ data }) => data);

export const uploadUserUtilityBill = (file, leadId, applicantId, docId) =>
  post(
    `lead/${leadId}/kyc/address/${applicantId}/utility/${docId}/upload`,
    file,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  )
    .then(({ data }) => {
      return data;
    })
    .catch(err => {
      return {
        isAxiosError: true,
        error: err.response
      };
    });

export const confirmingUserUtilityUploads = (
  leadId,
  applicantId,
  docId,
  docName
) =>
  put(
    `lead/${leadId}/kyc/address/${applicantId}/utility/${docName}/${docId}/uploaded`,
    {},
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  )
    .then(({ data }) => {
      return data;
    })
    .catch(err => {
      return {
        isAxiosError: true,
        error: err.response
      };
    });

//lead profile status
// /lead/{lead-id}/profile
export const getLeadProfileStatus = leadId =>
  get(`lead/${leadId}/profile`).then(({ data }) => {
    return data;
  });
// Update Loan Amount in Lead Profile
export const updateLoanAmount = (leadId, body) =>
  put(
    `lead/${leadId}/loan-amount?loan-amount=${body}`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

// Lead profile overview
export const getProfileOverview = (leadId, applicantId, overView) =>
  get(`lead/${leadId}/profile/${applicantId}/${overView}`).then(
    ({ data }) => data
  );
//Get List of States with Id
export const getStatesList = () =>
  get('master/states').then(({ data }) => data);

export const GETAPI = (leadId, leadApplicantId, doc) =>
  get(`lead/${leadId}/kyc/${doc}/${leadApplicantId}`).then(({ data }) => data);

//Get List of Boards based on State
export const getBoardsList = state =>
  get(`master/electric-board?state=${state}`).then(({ data }) => data);

export const getAddressProof = (leadId, leadApplicantId, doc) =>
  get(`lead/${leadId}/kyc/address/${leadApplicantId}/${doc}`).then(
    ({ data }) => data
  );

//Get The Address Details of the doc from unique id
export const getUtilityAddressDetails = (leadId, applicantId, doc, id) =>
  get(`lead/${leadId}/kyc/address/${applicantId}/utility/${doc}/${id}`).then(
    ({ data }) => data
  );

//Get the User KYC Utility billl Previous Data
export const getUserKYCUtility = (leadId, applicantId, doc) =>
  get(`lead/${leadId}/kyc/address/${applicantId}/utility/${doc}`).then(
    ({ data }) => data
  );

// Saves User KYC Utility Bills Details
export const saveKYCUtilityAddressProof = (leadId, applicantId, doc, body) =>
  post(
    `lead/${leadId}/kyc/address/${applicantId}/utility/${doc}/save`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  )
    .then(({ data }) => {
      return data;
    })
    .catch(err => {
      return {
        isAxiosError: true,
        error: err.response
      };
    });
//Upload eBill

export const UploadUserElectricityBill = (file, leadId, applicantId) =>
  post(
    `lead/${leadId}/kyc/address/${applicantId}/electricity/upload`,
    file,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  )
    .then(({ data }) => {
      return data;
    })
    .catch(err => {
      return {
        isAxiosError: true,
        error: err.response
      };
    });

export const ConfirmingUserElectricityUploads = (leadId, applicantId, docId) =>
  put(
    `lead/${leadId}/kyc/address/${applicantId}/electricity/${docId}/uploaded`,
    {},
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  )
    .then(({ data }) => {
      return data;
    })
    .catch(err => {
      return {
        isAxiosError: true,
        error: err.response
      };
    });

export const saveKYCElectricityAddressProof = (leadId, applicantId, body) =>
  post(
    `lead/${leadId}/kyc/address/${applicantId}/electricity/save`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  )
    .then(({ data }) => {
      return data;
    })
    .catch(err => {
      return {
        isAxiosError: true,
        error: err.response
      };
    });

export const getElectricityAddressDetails = (
  leadId,
  applicantId,
  electricityboard,
  id
) =>
  get(
    `lead/${leadId}/kyc/address/${applicantId}/electricity/verify?electricity-board=${electricityboard}&consumer-id=${id}`
  ).then(({ data }) => data);

export const getUserKYCElectricity = (leadId, applicantId) =>
  get(`lead/${leadId}/kyc/address/${applicantId}/electricity`).then(
    ({ data }) => data
  );

export const GetAddressProof = (leadId, leadApplicantId, doc) =>
  get(`lead/${leadId}/kyc/address/${leadApplicantId}/${doc}`).then(
    ({ data }) => data
  );

//income api's
// Chosse profession API
export const addProfession = (leadId, applicantId, body) =>
  put(
    `lead/${leadId}/${applicantId}/profession`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

// Income Upload API
export const incomeDocUpload = (
  file,
  leadId,
  applicantId,
  doc,
  tag = '',
  contentType = { 'Content-Type': 'application/json' }
) =>
  post(
    `lead/${leadId}/${applicantId}/income/salaried/${doc}/upload/${tag}`,
    file,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      ...contentType
    }
  ).then(({ data }) => data);

export const incomeDocUploaded = (leadId, applicantId, docId, doc) =>
  put(
    `lead/${leadId}/${applicantId}/income/salaried/${doc}/${docId}/uploaded`
  ).then(({ data }) => data);
//uploaded form16

// get api's for income
export const getIncomeSalaryDoc = (leadId, leadApplicantId, doc, subDoc) =>
  get(`lead/${leadId}/${leadApplicantId}/${doc}/salaried/${subDoc}`).then(
    ({ data }) => data
  );

//  api's for professional and employement details
export const EmpDocUpload = (
  file,
  leadId,
  applicantId,
  doc,
  contentType = { 'Content-Type': 'application/json' }
) =>
  post(
    `lead/${leadId}/${applicantId}/profession/${doc}/upload`,
    file,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      ...contentType
    }
  ).then(({ data }) => data);
export const EmpDocUploaded = (leadId, applicantId, docId, doc) =>
  put(`lead/${leadId}/${applicantId}/profession/${docId}/${doc}/uploaded`).then(
    ({ data }) => data
  );
export const submitDetails = (leadId, applicantId, body) =>
  put(
    `lead/${leadId}/${applicantId}/profession/salaried`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization'
    }
  ).then(({ data }) => data);

////master/industry/sections
export const getIndustryTypeProfessionDetail = () =>
  get(`master/industry/sections`).then(({ data }) => {
    return data;
  });

export const getCompanies = (name = '') =>
  get(`master/company/search?name=${name}`).then(({ data }) => data);

export const getBankNameFromIFSC = ifsc =>
  Axios.get(`https://ifsc.razorpay.com/${ifsc}`).then(({ data }) => data);

export const getApplicantBankAccount = (leadId, applicantId) =>
  get(`lead/${leadId}/${applicantId}/bank-account`).then(({ data }) => data);

export const addApplicantBankAccount = (leadId, applicantId, body) =>
  post(
    `lead/${leadId}/${applicantId}/bank-account`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const uploadIncomeBankStatement = (leadId, applicantId, tag) =>
  post(
    `lead/${leadId}/${applicantId}/bank-account/upload/${tag}`,
    {},
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const userBankStatementUploaded = (leadId, applicantId, docId) =>
  put(`lead/${leadId}/${applicantId}/bank-account/${docId}/uploaded`).then(
    ({ data }) => data
  );

export const userBankAccountDelete = (leadId, applicantId, accId) =>
  del(`lead/${leadId}/${applicantId}/bank-account/${accId}`).then(
    ({ data }) => data
  );

export const getApplicantBankAccountDetails = (
  leadId,
  applicantId,
  accReferenceId
) =>
  get(`lead/${leadId}/${applicantId}/bank-account/${accReferenceId}`).then(
    ({ data }) => data
  );

export const userBankAccountUpdate = (
  leadId,
  applicantId,
  accReferenceId,
  body
) =>
  put(
    `lead/${leadId}/${applicantId}/bank-account/${accReferenceId}`,
    body,
    {}
  ).then(({ data }) => data);

//other savings
export const saveOthersSaving = (leadId, applicantId, body) =>
  put(`lead/${leadId}/${applicantId}/income/other-savings`, body).then(
    ({ data }) => data
  );
export const getOtherSavings = (leadId, applicantId) =>
  get(`lead/${leadId}/${applicantId}/income/other-savings`).then(({ data }) => {
    return data;
  });

// get api for pesonalDetails
export const getPersonalDetails = (leadId, applicantId) =>
  get(`lead/${leadId}/${applicantId}/personal-details`).then(({ data }) => {
    return data;
  });

//api for Personal Details
export const EmpPersonalDocUpload = (
  file,
  leadId,
  applicantId,
  doc,
  contentType = { 'Content-Type': 'application/json' }
) =>
  post(
    `lead/${leadId}/${applicantId}/personal-details/${doc}/upload`,
    file,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      ...contentType
    }
  ).then(({ data }) => data);

export const EmpPersonalDocUploaded = (leadId, applicantId, docId, doc) =>
  put(
    `lead/${leadId}/${applicantId}/personal-details/${docId}/${doc}/uploaded`
  ).then(({ data }) => data);

//api for NRI Passport
export const EmpNRIPassUpload = (
  file,
  leadId,
  applicantId,
  tag = '',
  contentType = { 'Content-Type': 'application/json' }
) =>
  post(
    `lead/${leadId}/${applicantId}/personal-details/passport/upload/${tag}`,
    file,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      ...contentType
    }
  ).then(({ data }) => data);

// save personalDetails
export const savePersonalDetails = (leadId, applicantId, body) =>
  put(
    `lead/${leadId}/${applicantId}/personal-details`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization'
    }
  ).then(({ data }) => data);

// get for profession
export const getProfessionDetails = (leadId, applicantId) =>
  get(`lead/${leadId}/${applicantId}/profession/salaried`).then(({ data }) => {
    return data;
  });

// POST API for Loan Details
export const addObligation = (leadId, applicantId, body) =>
  post(
    `lead/${leadId}/${applicantId}/profession/obligation`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);
// Update Loan Deatils API
export const updateObligation = (leadId, applicantId, body, id) =>
  put(
    `lead/${leadId}/${applicantId}/profession/${id}/obligation`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);
// GET API for Loan Deatils
export const getObligation = (leadId, applicantId) =>
  get(`lead/${leadId}/${applicantId}/profession/obligation`).then(
    ({ data }) => {
      return data;
    }
  );
// Delete Loan Details
export const deleteLoanDetails = (leadId, applicantId, loanId) =>
  del(`lead/${leadId}/${applicantId}/profession/${loanId}/obligation`).then(
    ({ data }) => data
  );
// Loan Doc Uploaded
export const loanDocUpload = (
  file,
  leadId,
  applicantId,
  doc,
  contentType = { 'Content-Type': 'application/json' }
) =>
  post(
    `lead/${leadId}/${applicantId}/profession/obligation/${doc}/upload`,
    file,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      ...contentType
    }
  ).then(({ data }) => data);
export const loanDocUploaded = (leadId, applicantId, docId, doc) =>
  put(
    `lead/${leadId}/${applicantId}/profession/${docId}/obligation/${doc}/uploaded`
  ).then(({ data }) => data);

// KYC Rent Doc Upload
export const userKycRentUpload = (leadId, applicantId) =>
  post(
    `lead/${leadId}/kyc/residency/${applicantId}/rented/upload`,
    {},
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

// Rent Uploaded
export const userKycRentalAggrementUploaded = (leadId, applicantId, docId) =>
  put(
    `lead/${leadId}/kyc/residency/${applicantId}/rented/${docId}/uploaded`
  ).then(({ data }) => data);

// other income
export const itrDocUpload = (
  leadId,
  applicantId,
  docType = '',
  tag = '',
  contentType = { 'Content-Type': 'application/json' }
) =>
  post(
    `lead/${leadId}/${applicantId}/income/other-income/${docType}/upload/${tag}`,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      ...contentType
    }
  ).then(({ data }) => data);

export const itrDocUploaded = (leadId, applicantId, docId, docType) =>
  put(
    `lead/${leadId}/${applicantId}/income/other-income/${docType}/${docId}/uploaded`,
    {}
  ).then(({ data }) => data);
export const saveOtherIncome = (leadId, applicantId, body) =>
  put(`lead/${leadId}/${applicantId}/income/other-income`, body).then(
    ({ data }) => data
  );
export const getOtherIncomes = (leadId, applicantId) =>
  get(`lead/${leadId}/${applicantId}/income/other-income`).then(
    ({ data }) => data
  );
//api to check if number exist in AddLead
export const getPhoneNumberExist = phone =>
  get(`lead/phone-number-exists?phone=${phone} `).then(({ data }) => {
    return data;
  });

export const getLeadProertyDetails = leadId =>
  get(`lead/${leadId}/property/details `).then(({ data }) => {
    return data;
  });

export const saveLeadPropertyDetails = (leadId, body) =>
  put(`lead/${leadId}/property/details `, body).then(({ data }) => data);
// Add BT Loan Add API
export const addBtLoan = (leadId, body) =>
  put(
    `lead/${leadId}/bt`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);
// GET API for Loan Deatils
export const getBtLoan = leadId =>
  get(`lead/${leadId}/bt/existing-loans`).then(({ data }) => {
    return data;
  });

export const getBt = leadId =>
  get(`lead/${leadId}/bt`).then(({ data }) => {
    return data;
  });
// api for cost sheet Upload
export const costSheetUpload = (
  leadId,
  docType,
  contentType = { 'Content-Type': 'application/json' }
) =>
  post(
    `lead/${leadId}/property/${docType}/upload`,
    {},
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      ...contentType
    }
  ).then(({ data }) => data);

// Cost sheet Uploaded
export const costSheetUploaded = (leadId, docType, docId) =>
  put(`lead/${leadId}/property/${docType}/${docId}/uploaded`).then(
    ({ data }) => data
  );

//save api CostSheet
export const saveCostEstimate = (leadId, body) =>
  put(
    `lead/${leadId}/property/cost-estimates`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  )
    .then(({ data }) => {
      return data;
    })
    .catch(err => {
      return {
        isAxiosError: true,
        error: err.response
      };
    });
//get Api for Cost Details
export const getCostEstimates = leadId =>
  get(`lead/${leadId}/property/cost-estimates`).then(({ data }) => {
    return data;
  });

export const getApplicantPropertAddress = leadId =>
  get(`lead/${leadId}/address`).then(({ data }) => {
    return data;
  });

export const savePropertyTilte = (leadId, body) =>
  put(
    `lead/${leadId}/propertytitle`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  )
    .then(({ data }) => {
      return data;
    })
    .catch(err => {
      return {
        isAxiosError: true,
        error: err.response
      };
    });

////seller save api
///lead/property/seller/kyc/{lead-id}/{property-id}
export const saveSellerDetails = (leadId, propertyID, body) =>
  put(
    `lead/property/seller/kyc/${leadId}/${propertyID}`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  )
    .then(({ data }) => {
      return data;
    })
    .catch(err => {
      return {
        isAxiosError: true,
        error: err.response
      };
    });

//const+const
export const sellerDocUpload = (
  leadId,
  fileName,
  contentType = { 'Content-Type': 'application/json' }
) =>
  post(
    `lead/${leadId}/property/${fileName}/upload`,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      ...contentType
    }
  ).then(({ data }) => data);
export const sellerDocUploaded = (leadId, fileName, docId) =>
  put(`lead/${leadId}/property/${fileName}/${docId}/uploaded`).then(
    ({ data }) => data
  );
export const getSellerDetails = (leadId, propertyID) =>
  get(`lead/property/seller/kyc/${leadId}/${propertyID}`).then(({ data }) => {
    return data;
  });

export const getAuditLogs = (
  auditLogFor,
  leadId,
  size,
  page,
  from,
  to,
  activityType
) =>
  get(
    `audit-log/${auditLogFor}?lead-id=${leadId}&size=${size}&page=${page}${
      from ? '&from=' + from : ''
    }${to ? '&to=' + to : ''}${activityType ? '&type=' + activityType : ''}`
  ).then(({ data }) => {
    return data;
  });
// get profession type
export const getProfessionType = (leadId, applicantId) =>
  get(`lead/${leadId}/${applicantId}/applicant`).then(({ data }) => {
    return data;
  });

export const getLeadDataInCMDashboard = (
  from,
  to,
  status,
  product_type,
  page,
  size,
  sort,
  sortDir,
  searchBy,
  targetMonth,
  rmId
) =>
  get(
    `dashboard/cm?from=${from}&to=${to}${status ? '&status=' + status : ''}${
      product_type ? '&productType=' + product_type : ''
    }${page ? '&page=' + page : ''}${size ? '&size=' + size : ''}${
      sort ? '&sort=' + `${sort},${sortDir}` : ''
    }${searchBy ? '&searchBy=' + searchBy : ''}
     ${targetMonth ? `&targetMonth=${targetMonth}` : ''}${
      rmId ? `&rmUserId=${rmId}` : ''
    }`
  ).then(({ data }) => {
    return data;
  });
///in-principal-timer-api
export const inPrincipalTimerApi = leadId =>
  post(
    `in-principle/${leadId}`,
    {},
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization'
    }
  ).then(({ data }) => {
    return data;
  });
// get Timer Api
export const getInPrincipalTimerApi = leadId =>
  get(`in-principle/${leadId}/timer`).then(({ data }) => {
    return data;
  });

// get docs inPrinciple
export const getInPrincipleDocs = (leadId, docType) =>
  get(`in-principle/${leadId}/documents/${docType}`).then(({ data }) => {
    return data;
  });
//verify doc
export const genericVerifyDoc = (leadId, docId) =>
  put(`in-principle/${leadId}/documents/${docId}/verified`).then(
    ({ data }) => data
  );
export const genericRejectDoc = (leadId, docId, msg) =>
  put(
    `in-principle/${leadId}/documents/${docId}/not-verified?reason=${msg}`
  ).then(({ data }) => data);

export const rejectInPrinciple = (leadId, body) =>
  put(`in-principle/${leadId}/reject`, body).then(({ data }) => data);

export const getInfoForInPrinciple = (leadId, infoType) =>
  get(`in-principle/${leadId}/${infoType}`).then(({ data }) => {
    return data;
  });
export const approveInPrinciple = (leadId, body) =>
  post(`in-principle/${leadId}/approve`, body).then(({ data }) => data);

//comments post apis
export const commentsPostApi = (docId, comment = '') =>
  post(
    `lead/documents/${docId}/comments`,
    comment,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => {
    return data;
  });
// comments get  Api
export const commentGetApi = docId =>
  get(`lead/documents/${docId}/comments`).then(({ data }) => {
    return data;
  });
//comment delete api

export const commentDeleteApi = (docId, commentId) =>
  del(`lead/documents/${docId}/comments/${commentId}`).then(data => data);
// Generate PDF Doc and Get PDF URL for CM

export const getPDFDoc = leadId =>
  get(`lead/${leadId}/pdf`).then(({ data }) => {
    return data;
  });

// Move to in principle check API
export const checkApproval = leadId =>
  get(`in-principle/${leadId}/check-approval`).then(({ data }) => {
    return data;
  });

export const getSelpEmployeedDetails = (leadId, applicantId) =>
  get(`lead/${leadId}/${applicantId}/profession/self-employed`).then(
    ({ data }) => data
  );

export const addSelpEmployeedDetails = (leadId, applicantId, body) =>
  put(`lead/${leadId}/${applicantId}/profession/self-employed`, body).then(
    ({ data }) => data
  );

export const getnatureOfBusinessLists = () =>
  get(`master/industry/sections`).then(({ data }) => data);

export const getIndustryLists = sectionId =>
  get(`master/industry/division?sectionid=${sectionId}`).then(
    ({ data }) => data
  );

export const getSubIndustryData = divID =>
  get(`master/industry/groups?divisionid=${divID}`).then(({ data }) => data);

export const getBusinessAddress = (leadId, applicantId) =>
  get(`lead/${leadId}/${applicantId}/business-address`).then(
    ({ data }) => data
  );

export const confirmBusinessAddress = (leadId, applicantId) =>
  post(
    `lead/${leadId}/${applicantId}/profession/self-employed/save/kyc-address`,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => {
    return data;
  });

export const getUploadUrlForBusinessAddressProof = (
  leadId,
  applicantId,
  addressProof
) =>
  post(
    `lead/${leadId}/${applicantId}/business-address/${addressProof}/upload`,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => {
    return data;
  });

export const confirmBusinessAddressProofUploaded = (
  leadId,
  applicantId,
  docId,
  addressProof
) =>
  put(
    `lead/${leadId}/${applicantId}/business-address/${addressProof}/${docId}/uploaded`
  ).then(({ data }) => data);

export const saveBusinessAddressProof = (
  leadId,
  applicantId,
  body,
  addressProof
) =>
  post(
    `lead/${leadId}/${applicantId}/business-address/${addressProof}/save`,
    body,

    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => {
    return data;
  });

export const getBusinessAddressProof = (leadId, applicantId, addressProof) =>
  get(`lead/${leadId}/${applicantId}/business-address/${addressProof}`).then(
    ({ data }) => data
  );

export const businessAddressProofElectricityBillVerify = (
  leadId,
  applicantId,
  board,
  consumerId
) =>
  get(
    `lead/${leadId}/${applicantId}/business-address/electricity/verify?electricity-board=${board}&consumer-id=${consumerId}`
  ).then(({ data }) => data);

export const getUtilityDetailsForBusinessAdressProof = (
  leadId,
  applicantId,
  addressProof,
  consumerId
) =>
  get(
    `lead/${leadId}/${applicantId}/business-address/${addressProof}/verify?consumer-id=${consumerId}`
  ).then(({ data }) => data);

export const getPNGForBusinessAdressProof = (
  leadId,
  applicantId,
  addressProof,
  parameters
) =>
  get(
    `lead/${leadId}/${applicantId}/business-address/${addressProof}/verify`,
    parameters
  ).then(({ data }) => data);

export const getCompanyDetails = company_name =>
  get(`master/company/search?name=${company_name}`).then(({ data }) => data);
// In Principle GET API to show RM
export const getInPrincipleSanction = leadId =>
  get(`in-principle/${leadId}/approved-sanction`).then(({ data }) => {
    return data;
  });

export const getBusinessDirectorList = (leadId, applicantId) =>
  get(
    `lead/${leadId}/${applicantId}/profession/self-employed/company/directors`
  ).then(({ data }) => {
    return data;
  });

export const addNewBusinessDirector = (leadId, applicantId, body) =>
  post(
    `lead/${leadId}/${applicantId}/profession/self-employed/company/director`,
    body,
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

// Send Email to Customer
export const sendInPrincipalEmail = leadId =>
  post(
    `in-principle/${leadId}/email-customer`,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const getBusinessAddressProofITRUploadedUrl = (
  leadId,
  applicantId,
  docTag
) =>
  post(
    `lead/${leadId}/${applicantId}/business-address/itr/upload/${docTag}`
  ).then(({ data }) => data);

export const getUploadUrlForBusinessProofLLP = (
  leadId,
  applicantId,
  addressProof
) =>
  post(
    `lead/${leadId}/${applicantId}/business-address/${addressProof}`,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => {
    return data;
  });

// get the property details inprinciple

export const getPropertyDetails = leadId =>
  get(`in-principle/${leadId}/property-details`).then(({ data }) => {
    return data;
  });

// get Bank Name to send Documents
export const getBankCities = () =>
  get(`master/bank/city`).then(({ data }) => {
    return data;
  });
// get Branch  Name to send Documents
export const getBankBranch = cityId =>
  get(`master/bank/branches/${cityId}`).then(({ data }) => {
    return data;
  });
// get Branch contact details to send Documents
export const getBankBranchContact = (branchId, leadId) =>
  get(`in-principle/${leadId}/bank/${branchId}/contact-details`).then(
    ({ data }) => {
      return data;
    }
  );
// Send Email to Bank Executive
export const sendMailToBank = (leadId, contactId) =>
  post(
    `in-principle/${leadId}/bank/email`,
    contactId,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

// get company details in-principle
export const getCompanyDetailsInPrincple = leadId =>
  get(`in-principle/${leadId}/company-details`).then(({ data }) => {
    return data;
  });
export const addPrtnerInBusinessIncome = (leadId, applicantId, body) =>
  put(`lead/${leadId}/${applicantId}/profession/self-employed/partner`, body, {
    'Access-Control-Expose-Headers': 'Authorization',
    'Content-Type': 'application/json'
  }).then(({ data }) => data);

export const getPartnersInBusinessIncome = (leadId, applicantId) =>
  get(`lead/${leadId}/${applicantId}/profession/self-employed/partner`).then(
    ({ data }) => data
  );

export const delPartnerInBusinessIncome = (leadId, applicantId, partnerId) =>
  del(
    `lead/${leadId}/${applicantId}/profession/self-employed/${partnerId}/partner}`
  ).then(data => data);

// sep get api medial qualification
export const getDropDownOptionsAPI = name =>
  get(`master/professional-qualification?field=${name}`).then(({ data }) => {
    return data;
  });

// sep get medical council api
export const getMedicalCouncilAPI = () =>
  get(`master/medical-council`).then(({ data }) => {
    return data;
  });

export const SEPsaveAPI = (leadId, applicantId, body) =>
  put(`lead/${leadId}/${applicantId}/self-employed/professional`, body, {
    'Access-Control-Expose-Headers': 'Authorization',
    'Content-Type': 'application/json'
  }).then(({ data }) => data);

// add business details

export const addBusinessDetail = (leadId, applicantId, body) =>
  put(
    `lead/${leadId}/${applicantId}/self-employed/professional/business-details`,
    body,
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const getSEPProfessionAPI = (leadId, applicantId) =>
  get(`lead/${leadId}/${applicantId}/self-employed/professional`).then(
    ({ data }) => data
  );

// upload SEP

export const SEPUploadCertificateAPI = (leadId, applicantId) =>
  post(
    `lead/${leadId}/${applicantId}/self-employed/professional/certificate/upload`,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => {
    return data;
  });
export const SEPUploadedCertificateAPI = (leadId, applicantId, docId) =>
  put(
    `lead/${leadId}/${applicantId}/self-employed/professional/certificate/${docId}/uploaded`
  ).then(({ data }) => data);

// get LAP certificate api
export const getSEPCertificateAPI = (leadId, applicantId) =>
  get(
    `lead/${leadId}/${applicantId}/self-employed/professional/certificate`
  ).then(({ data }) => data);

// get business details

export const getBusinessDetail = (leadId, applicantId) =>
  get(`lead/${leadId}/${applicantId}/self-employed/professional`).then(
    ({ data }) => data
  );

// company pan lap
export const companyPanUpload = (leadId, applicantId) =>
  post(`lead/${leadId}/kyc/company/pan/${applicantId}/upload`).then(
    ({ data }) => data
  );

// company pan Ocr
export const companyPanOcr = (leadId, applicantId, docId) =>
  put(`lead/${leadId}/kyc/company/pan/${applicantId}/${docId}`).then(
    ({ data }) => data
  );
// individual to company
export const lapIndToComp = (leadId, applicantId, body) =>
  put(`lead/${leadId}/lap/${applicantId}`, body).then(({ data }) => data);

// get api Company pan
export const getCompanyPan = (leadId, applicantId) =>
  get(`lead/${leadId}/kyc/company/pan/${applicantId}`).then(({ data }) => data);

// verifyCompanyPan
export const verifyCompanyPan = (leadId, applicantId, body) =>
  put(`lead/${leadId}/kyc/company/pan/${applicantId}/verify`, body).then(
    ({ data }) => data
  );

//get LAP Type
export const getLAPType = () =>
  get('master/loans/product?productId=2').then(({ data }) => data);

// getLAPProperty
export const getLAPPropertyAPI = leadId =>
  get(`lead/${leadId}/lap/property`).then(({ data }) => data);

//LAP  update API
export const updateLAPPropertyAPI = (leadId, body) =>
  put(`lead/${leadId}/lap/property`, body).then(({ data }) => data);

//final sanction update api
export const finalSanctionUpdateAPI = (leadId, doc, body) => {
  return put(`sanction/${leadId}/${doc}`, body).then(({ data }) => data);
};

//Final sanction get api
export const finalSanctionGETAPI = (leadId, doc) =>
  get(`sanction/${leadId}/${doc}`).then(({ data }) => data);

//upload final sanction legal
export const LegalUpload = leadId =>
  post(
    `sanction/${leadId}/legal/legal-report/upload`,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => {
    return data;
  });
//final sanction legal uploaded
export const LegalUploaded = (leadId, docId) =>
  put(`sanction/${leadId}/legal/legal-report/${docId}/uploaded`).then(
    ({ data }) => data
  );

//Processing Fee Upload Api
export const uploadProcessingFee = leadId =>
  post(
    `bank-login/${leadId}/processing-fee/upload`,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => {
    return data;
  });

//Processing Fee Uploaded
export const processingFeeuploaded = (leadId, docId) =>
  put(`bank-login/${leadId}/processing-fee/${docId}/uploaded`).then(
    ({ data }) => data
  );

//LoginDetails  save api
export const saveLoginDetailsapi = (leadId, body) =>
  post(`bank-login/${leadId}`, body, {
    'Access-Control-Expose-Headers': 'Authorization',
    'Content-Type': 'application/json'
  }).then(({ data }) => data);

//get api log in details
export const getLoginDetailsApi = leadId =>
  get(`bank-login/${leadId}`).then(({ data }) => data);

// company as Co Applicant
export const addCompanyCoApplicant = (leadId, body) =>
  post(`lead/${leadId}/lap/applicant`, body, {
    'Access-Control-Expose-Headers': 'Authorization',
    'Content-Type': 'application/json'
  }).then(({ data }) => data);

export const uploadValuationDocs = (leadId, docName, tag) =>
  post(`sanction/${leadId}/valuation/${docName}/upload/${tag}`, {}).then(
    ({ data }) => data
  );

export const uploadedValuationDocs = (leadId, docName, docId) =>
  put(`sanction/${leadId}/valuation/${docName}/${docId}/uploaded`).then(
    ({ data }) => data
  );

export const addUpdateTheSanction = (leadId, sanctionType, body) =>
  put(`sanction/${leadId}/${sanctionType}`, body).then(({ data }) => data);

export const getValuationDetails = leadId =>
  get(`sanction/${leadId}/valuation`).then(({ data }) => data);

//disbursement upload api
export const uploadDisbursementDocs = (
  leadId,
  docName,
  contentType = { 'Content-Type': 'application/json' }
) =>
  post(
    `disbursement/${leadId}/${docName}/upload`,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      ...contentType
    }
  ).then(({ data }) => data);

export const uploadedDisbusementDocs = (leadId, docName, docId) =>
  put(`disbursement/${leadId}/${docName}/${docId}/uploaded`).then(
    ({ data }) => data
  );

//save disbursement api
export const saveDisbursementApi = (leadId, body) =>
  put(`disbursement/${leadId}`, body, {
    'Access-Control-Expose-Headers': 'Authorization',
    'Content-Type': 'application/json'
  }).then(({ data }) => data);

//get Api
export const getDisbursementDetailsApi = leadId =>
  get(`disbursement/${leadId}`).then(({ data }) => data);
//upload final sanction
// /sanction/{lead-id}/final-sanction
export const finalSanctionUpload = leadId =>
  post(
    `sanction/${leadId}/final-sanction/sanction-letter/upload`,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => {
    return data;
  });
//final sanction  uploaded
export const finalSanctionUploaded = (leadId, docId) =>
  put(
    `sanction/${leadId}/final-sanction/sanction-letter/${docId}/uploaded`
  ).then(({ data }) => data);

//move to disbursement api final sanction
export const moveToDisbursementAPI = leadId =>
  post(
    `sanction/${leadId}/disbursement`,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => {
    return data;
  });

export const requestCreditReport = (leadId, applicantId) =>
  put(`lead/${leadId}/profile/${applicantId}/credit-report/request`).then(
    ({ data }) => data
  );
//get credit report
export const getCreditReport = () =>
  put(`consumer/credit-report/experian`).then(({ data }) => data);

export const viewCreditReportRmBpSide = (leadId, applicantId) =>
  get(`lead/${leadId}/profile/${applicantId}/credit-report`).then(
    ({ data }) => data
  );
//get khata based on city
export const getKhataListbyCity = city =>
  get('master/propertyTitles/city?city=' + city).then(({ data }) => data);

export const getAvailableListsForReassign = leadId =>
  get(`lead/${leadId}/reassign/options`).then(({ data }) => data);

export const assigneNewOwner = (leadId, newOwner) =>
  put(`lead/${leadId}/reassign/${newOwner}`).then(({ data }) => data);

export const getAllLeads = (
  fromDate,
  toDate,
  page,
  size,
  searchBy,
  sort,
  sortDir = 'ASC',
  filter,
  rm,
  productId,
  source
) =>
  get(
    `dashboard/leads?&from=${fromDate}&to=${toDate}&page=${page}&size=${size}${
      searchBy ? `&searchBy=${searchBy}` : ''
    }${filter ? `&status=${filter}` : ''}${
      sort ? `&sort=${sort},${sortDir.toUpperCase()}` : ''
    }${rm ? `&rmUserId=${rm}` : ''}${
      productId ? `&productId=${productId}` : ''
    }${source ? `&leadSourceId=${source}` : ''}`
  ).then(({ data }) => data);

export const editTargetMonth = (leadId, target) =>
  put(`lead/${leadId}/target-month?target=` + target).then(({ data }) => data);

export const getPD = leadId =>
  get(`lead/${leadId}/pd`).then(({ data }) => data);
export const addOrEditLead = (body, leadId) =>
  put(
    `lead/dashboard/all-lead?${leadId ? `lead-id=${leadId}` : ''}`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

//personal discussion API
export const savePDInfoAPI = (body, leadId) =>
  put(
    `lead/${leadId}/pd`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization'
    }
  ).then(({ data }) => data);

export const actionOnLeadInPD = (leadId, body, endpoint) =>
  put(`lead/${leadId}/pd/${endpoint}`, body).then(({ data }) => data);

export const getTeamPerformanceReport = (
  targetMonth,
  page,
  size,
  cityId,
  rm,
  products,
  sortColumn,
  sortDir = 'DESC',
  source
) =>
  get(
    `report/team?targetMonth=${targetMonth}&page=${page}&size=${size}${
      cityId ? `&cityId=${cityId}` : ''
    }${rm ? `&rmUserId=${rm}` : ''}${products ? `&productId=${products}` : ''}${
      sortColumn ? `&sort=${sortColumn},${sortDir.toUpperCase()}` : ''
    }${source ? `&leadSourceId=${source}` : ''}`
  ).then(({ data }) => data);

// submit application rating and feedback (consumer-ui)
export const submitFeedback = body =>
  post(
    `consumer/loan/feedback`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);
export const getBankPerformanceReport = (
  targetMonth,
  page,
  size,
  productId,
  cityId,
  bankId,
  source
) =>
  get(
    `report/bank?targetMonth=${targetMonth}&pageNumber=${page}&pageSize=${size}${
      productId ? `&productId=${productId}` : ''
    }${cityId ? `&cityId=${cityId}` : ''}${bankId ? `&bankId=${bankId}` : ''}${
      source ? `&leadSourceId=${source}` : ''
    }`
  ).then(({ data }) => data);
//get List of Banks
export const getBankList = () =>
  get(`master/bank`).then(({ data }) => {
    return data;
  });
// get individual performance report
export const getIndividualPerformanceReport = (rmUserId, year) =>
  get(`report/team/employee?rmUserId=${parseInt(rmUserId)}&year=${year}`).then(
    ({ data }) => data
  );
//get P/L Report
export const getPLReport = year =>
  get(`report/pl/kpi?year=${year}`).then(({ data }) => data);
//get P/L income Report
export const getPLIncomeReport = year =>
  get(`report/pl/income?year=${year}`).then(({ data }) => data);

// get zone list
export const getZoneList = () => get('master/region').then(({ data }) => data);

// get city list //
export const getCityZoneWiseOrStateWise = (state = 0, zone) =>
  get(`master/cities?state=${state}${zone ? `&zone=${zone}` : ''}`).then(
    ({ data }) => data
  );

/* Gets the list of Product Group */
export const getProductGroup = () =>
  get(`master/product-group`).then(({ data }) => data);

/* Get List of Loan type By Product Group */
export const getProductByGroupId = groupId =>
  get(`master/loans/product/${groupId}/product-group`).then(({ data }) => data);

/* Create Financial Commission of Financial Unit. */
export const createCommisssion = body =>
  put(`finance-institute/unit/commission`, body).then(({ data }) => data);
//add bank unit
export const addBankUnitAPI = body =>
  post(
    `finance-institute/unit`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

//get bank unit list
export const getBankUnitListAPI = FiId =>
  get(`finance-institute/unit?id=${FiId}`).then(({ data }) => {
    return data;
  });
/* finance-institute/unit/commission */
export const getCommissionFIUnits = (unitId, pageNumber, pageSize) =>
  get(
    `finance-institute/unit/commission?unitId=${unitId}&page=${pageNumber}&size=${pageSize}`
  ).then(({ data }) => data);

///report/bank-disbursement
export const getBankDisbursementReport = (
  disbursedMonth,
  productId,
  bankId,
  source
) =>
  get(
    `report/bank-disbursement?disbursedMonth=${disbursedMonth}${
      productId ? `&productId=${productId}` : ''
    }${bankId ? `&bankId=${bankId}` : ''}${
      source ? `&leadSourceId=${source}` : ''
    }`
  ).then(({ data }) => data);

export const getSourceList = () =>
  get(`master/lead/source`).then(({ data }) => data);

export const makeACall = (leadId, applicantId) =>
  post(
    `calling/${leadId}/lead/${applicantId}/applicant`,
    {},
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const addFICommissionBonus = body =>
  post(
    `finance-institute/unit/commission/bonus`,
    body,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const getFICommissionBonus = unitId =>
  get(`finance-institute/unit/commission/bonus?unitId=${unitId}`).then(
    ({ data }) => data
  );

export const getReportTotal = ({
  type,
  targetMonth = '',
  rmUserId = '',
  productId = '',
  cityId = '',
  leadSourceId = '',
  bankId = '',
  disbursedMonth = ''
}) =>
  get(
    `report/${type}/total?targetMonth=${targetMonth}${rmUserId &&
      `&rmUserId=${rmUserId}`}${productId &&
      `&productId=${productId}`}${cityId &&
      `&cityId=${cityId}`}${leadSourceId &&
      `&leadSourceId=${leadSourceId}`}${bankId &&
      `&bankId=${bankId}`}${disbursedMonth &&
      `&disbursedMonth=${disbursedMonth}`}`
  ).then(({ data }) => data);

export const getReport = ({ report, number, size, startDate, endDate }) =>
  get(
    `report/${report}?page=${number}&size=${size}&from=${startDate}&to=${endDate}`
  ).then(({ data }) => data);

//call log

export const getCallLogsAPI = ({
  leadId = '',
  page,
  rows,
  fromDate,
  toDate,
  callType = '',
  rm = '',
  searchby = ''
}) =>
  get(
    `report/call-logs?page=${page ? page : ''}&size=${
      rows ? rows : ''
    }${fromDate && `&from=${fromDate}`}${toDate && `&to=${toDate}`}${rm &&
      `&rmId=${rm}`}${callType && `&callStatus=${callType}`}${leadId &&
      `&leadId=${leadId}`}${searchby && `&searchby=${searchby}`}`
  ).then(({ data }) => data);

// bank slab performance
export const getBankSlabPerformance = (leadStatus, bankSlabMonth) =>
  get(
    `report/slab-performance?leadStatus=${leadStatus}${
      bankSlabMonth ? `&targetMonth=${bankSlabMonth}` : ''
    }`
  ).then(({ data }) => data);

//financial Institute doc upload
export const financialInstituteDocUpload = (
  fiId,
  contentType = { 'Content-Type': 'application/json' }
) =>
  post(
    `finance-institute/${fiId}/commission-doc/upload`,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      ...contentType
    }
  ).then(({ data }) => data);

export const financialInstituteDocUploaded = (fiId, docId) =>
  post(`finance-institute/${fiId}/commission-doc/${docId}/uploaded`).then(
    ({ data }) => data
  );

export const financialInstituteGetAPI = fiId =>
  get(`finance-institute/${fiId}/commission-doc`).then(({ data }) => data);

// whatsApp Notification

export const notificationGetAPI = ({ pageNo, perPageResult }) =>
  get(
    `notification?page=${pageNo ? pageNo : 0}&size=${
      perPageResult ? perPageResult : ''
    }`
  ).then(({ data }) => data);

export const notificationAsReadAPI = notificationId =>
  post(
    `notification/mark-read${notificationId ? `?id=${notificationId}` : ''}`
  ).then(({ data }) => data);

export const whatsAppConversations = ({
  leadId,
  applicantId,
  latestPage,
  page,
  size
}) =>
  get(
    `whatsapp/conversation?leadId=${leadId}&applicantId=${applicantId}${`&getLatestPage=${latestPage}`}${
      page ? `&page=${page}` : ''
    }${size ? `&size=${size}` : ''}`
  ).then(({ data }) => data);

export const sendMessageToWhatsApp = body =>
  post(`whatsapp/sessionMessage`, body)
    .then(({ data }) => data)
    .catch(error => error);

export const getNotificationCount = () =>
  get(`notification/count`).then(({ data }) => data);

export const getUserChatListWhatsApp = ({ page, size, searchParameter }) =>
  get(
    `whatsapp/all-messages?page=${page}&size=${size}${searchParameter &&
      `&searchby=${searchParameter}`}`
  ).then(({ data }) => data);
export const markWhatsAppMessageAsRead = (leadId, applicantId) =>
  put(`whatsapp/incoming-message/${leadId}/${applicantId}/read`).then(
    ({ data }) => data
  );
export const markWhatsAppMessageAsReadForUnKnownNumber = number =>
  put(`whatsapp/incoming-message/${number}/read`).then(({ data }) => data);

export const whatsAppConversationsByNumber = ({
  phoneNumber,
  latestPage,
  page,
  size
}) =>
  get(
    `whatsapp/conversation/unknown-number?${`unknownNumber=${phoneNumber}&getLatestPage=${latestPage}`}${
      page ? `&page=${page}` : ''
    }${size ? `&size=${size}` : ''}`
  ).then(({ data }) => data);

export const getFunnelReport = ({ from, to, rm, source, city }) =>
  get(
    `report/lead/funnel-report?from=${from}&to=${to}${
      rm ? `&rmUserId=${rm}` : ''
    }${source ? `&leadSource=${source}` : ''}`
  ).then(({ data }) => data);

export const getReflexReport = ({
  from,
  to,
  pageNumber,
  pageSize,
  rm,
  source
}) =>
  get(
    `report/lead/influx-report?from=${from}&to=${to}&page=${pageNumber}&size=${pageSize}${
      rm ? `&rmUserId=${rm}` : ''
    }${source ? `&leadSource=${source}` : ''}`
  ).then(({ data }) => data);
export const CAMApproveDoc = (leadId, docId) =>
  put(`in-principle/${leadId}/cam/${docId}/verified`).then(({ data }) => data);

export const CAMRejectDoc = (leadId, docId, msg) =>
  put(`in-principle/${leadId}/cam/${docId}/not-verified?reason=${msg}`).then(
    ({ data }) => data
  );

export const CAMgetAPI = leadId =>
  get(`in-principle/${leadId}/cm-report/cam`).then(({ data }) => data);

export const addDisbursement = (leadId, body) =>
  post(
    `disbursement/${leadId}`,
    body,
    {},
    {
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);
export const assignNewCM = (leadId, newOwner) =>
  put(`lead/${leadId}/reassign/${newOwner}`).then(({ data }) => data);
export const deleteBankLogin = (leadId, data) =>
  del(`bank-login/${leadId}`, data).then(({ data }) => data);
export const getFincialInstitutions = (page, size) =>
  get(`finance-institute?page=${page}&size=${size}`).then(({ data }) => data);
export const getRejectedBanksFromLogin = leadId =>
  get(`bank-login/${leadId}/rejected`).then(({ data }) => data);
export const hardRejectTheApplication = (leadId, message) =>
  put(
    `in-principle/${leadId}/reject-and-close`,
    message,
    {},
    {
      'Content-Type': 'text/plain'
    }
  ).then(({ data }) => data);

export const markAsFullyDisbursed = leadId =>
  post(
    `disbursement/${leadId}/fully-disbursed`,
    {},
    {},
    {
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);
export const uploadDocCAM = (
  leadId,
  docName,
  contentType = { 'Content-Type': 'application/json' }
) =>
  post(
    `in-principle/${leadId}/${docName}/upload`,
    {},
    {
      'Access-Control-Expose-Headers': 'Authorization',
      ...contentType
    }
  ).then(({ data }) => data);
export const whatsAppReceiveDocAPI = leadId =>
  get(`lead/${leadId}/whatsapp-docs`).then(({ data }) => data);

export const uploadedDocCAM = (leadId, docName, docId) =>
  put(`in-principle/${leadId}/${docName}/${docId}/uploaded`).then(
    ({ data }) => data
  );

export const getMissedCallReport = ({ from, to, pageNumber, pageSize, rm }) =>
  get(
    `report/lead/missedCall-report?from=${from}&to=${to}&page=${pageNumber}&size=${pageSize}${
      rm ? `&rmUserId=${rm}` : ''
    }`
  ).then(({ data }) => data);

export const sendWhatsAppDocAPI = ({
  leadId,
  applicantId,
  profession,
  employerType = ''
}) =>
  put(
    `lead/${leadId}/${applicantId}/send-doc-checklist?profession=${profession}${
      employerType ? `&employer-type=${employerType}` : ''
    }`
  ).then(({ data }) => data);

export const getLeadBankStatements = ({ leadId }) =>
  get(`lead/${leadId}/bank-statement`).then(({ data }) => data);

export const getBankDisbursementDetailReport = ({
  fromDate,
  toDate,
  rm,
  page,
  pageSize
}) =>
  get(
    `report/lead/disbursed_Report?from=${fromDate}&to=${toDate}&page=${page}&size=${pageSize}${
      rm ? `&rmUserId=${rm}` : ''
    }`
  ).then(({ data }) => data);

export const getBankDisbusementSummary = ({ fromDate, toDate, rm }) =>
  get(
    `report/disbursement-report/aggregate?from=${fromDate}&to=${toDate}${
      rm ? `&rmUserId=${rm}` : ''
    }`
  ).then(({ data }) => data);

export const leadRejectAndClose = ({ leadId, body }) =>
  del(`lead/${leadId}/reject-and-close`, body).then(({ data }) => data);

export const getDocSignedUrl = docId =>
  get(`lead/documents/${docId}`).then(({ data }) => data);

export const leadPropertyIdentified = leadId =>
  get(`lead/${leadId}/property-identified`).then(({ data }) => data);

export const updateLeadPropertyIdentified = (leadId, propertyIdentified) =>
  put(
    `lead/${leadId}/property-identified`,
    propertyIdentified,
    {},
    { 'Content-Type': 'application/json' }
  ).then(({ data }) => data);

export const getIpv6 = () =>
  Axios.get('https://ipv6.jsonip.com/').then(({ data }) => data);

export const getIpv4 = () =>
  Axios.get('https://ipv4.jsonip.com/').then(({ data }) => data);

export const getTruecallerData = requestID =>
  Axios.get(`${baseUrl}/truecaller/${requestID}`).then(({ data }) => data);

export const getBreDocByruleName = ruleName =>
  get(`bre/kyc/documents/{variable_name}?name=${ruleName}`).then(
    ({ data }) => data
  );

export const breSaveNewRule = payload =>
  post(
    `bre/kyc/conditions`,
    payload,
    {},
    {
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const getBReKycRules = ({ pageNumber, pageSize }) =>
  get(`bre/kyc/AllConditions?page=${pageNumber}&size=${pageSize}`).then(
    ({ data }) => data
  );

export const updateBRERules = (id, data) =>
  put(
    `bre/kyc/update/conditions/${id}`,
    data,
    {},
    { 'Content-Type': 'application/json' }
  ).then(({ data }) => data);

export const deleteBreRule = ruleId =>
  del(`bre/kyc/delete/condition/${ruleId}`).then(({ data }) => data);

export const AnalyzeBreDoc = ({ type, leadId }) =>
  post(`bre/${type}/analyse/${leadId}`).then(({ data }) => data);

export const getBreAnalyzeData = leadId =>
  get(`bre/kyc/AllAnalyzedData?leadId=${leadId}`).then(({ data }) => data);

export const getIndustriesList = () =>
  get(`master/company/industry`).then(({ data }) => data);

export const getCompanyTypeList = () =>
  get(`master/company/type`).then(({ data }) => data);

export const getSegmentList = () =>
  get(`master/company/segments`).then(({ data }) => data);

export const addCompany = body =>
  get(
    `industry/add/company?companyName=${body.companyName}${body.industryId &&
      `&industryId=${body.industryId}`}${body.industryName &&
      `&industryName=${body.industryName}`}${body.docUrl &&
      `&docUrl=${body.docUrl}`}${body.segmentName &&
      `&segmentName=${body.segmentName}`}${body.typeOfCompany &&
      `&typeOfCompany=${body.typeOfCompany}`}`
  ).then(({ data }) => data);

export const getIndustryPresignedUrl = () =>
  get(`industry/get/presignedUrl`).then(({ data }) => data);

export const getIndustries = ({
  from,
  to,
  pageNumber = 0,
  pageSize,
  bank,
  companyRating,
  companyType,
  segmentRating,
  industryRating
}) =>
  get(
    `industry/filter/industries?forceFirstAndLastRels=true&paged=true${`&page=${pageNumber}`}${pageSize &&
      `&size=${pageSize}`}${`&from=${from}`}${`&to=${to}`}${bank &&
      `&bankIds=${bank}`}${companyType &&
      `&companyType=${companyType}`}${companyRating &&
      `&companyRatingList=${companyRating}`}${segmentRating &&
      `&segmentRatingsId=${segmentRating}`}${industryRating &&
      `&industryRatings=${industryRating}`}`
  ).then(({ data }) => data);

export const editCompany = body =>
  get(
    `industry/edit/company/${body.industryId}?companyName=${
      body.companyName
    }${body.industryId &&
      `&industryId=${body.industryId}`}${body.industryName &&
      `&industryName=${body.industryName}`}${body.docUrl &&
      `&docUrl=${body.docUrl}`}${body.segmentName &&
      `&segmentName=${body.segmentName}`}${body.typeOfCompany &&
      `&typeOfCompany=${body.typeOfCompany}`}`
  ).then(({ data }) => data);

export const getAllBanks = () => get(`master/bank`).then(({ data }) => data);

export const getCompanyRating = () =>
  get(`industry/get/companyRatings`).then(({ data }) => data);

export const getEmpanellingBankBranch = () =>
  get(`master/bank/city`).then(({ data }) => data);

export const addBank = body =>
  get(
    `industry/add/bank?companyId=${body.companyId}${body.bankName &&
      `&bankName=${body.bankName}`}${body.branchName &&
      `&branchName=${body.branchName}`}${body.companyRating &&
      `&companyRating=${body.companyRating}`}${body.segmentRating &&
      `&segmentRating=${body.segmentRating}`}${body.industryRating &&
      `&industryRating=${body.industryRating}`}${body.employerMasterNumber &&
      `&employerMasterNumber=${body.employerMasterNumber}`}`
  ).then(({ data }) => data);

export const getBankGradings = (companyId, bankId) =>
  get(`industry/get/bankGradings/${companyId}/${bankId}`).then(
    ({ data }) => data
  );

export const getIndustryDetails = id =>
  get(`industry/get/industry/${id}`).then(({ data }) => data);

export const editBank = (
  id,
  companyId,
  bankName,
  companyRating,
  branchName,
  employerMasterNumber,
  industryRating,
  segmentRating
) => {
  return get(
    `industry/edit/bank/${id}/${`?id=${id}`}${`&companyId=${companyId}`}${`&industryRating=${industryRating}`}${`&bankName=${bankName}`}${`&branchName=${branchName}`}${`&companyRating=${companyRating}`}${`&employerMasterNumber=${employerMasterNumber}`}${`&segmentRating=${segmentRating}`}`
  );
};

export const deleteIndustry = id =>
  get(`industry/delete/company/${id}`).then(({ data }) => data);

export const readPresignedUrl = url =>
  get(`industry/read/presignedUrl?fileLocation=${url}`).then(
    ({ data }) => data
  );

export const deleteBank = id =>
  get(`industry/delete/bank/${id}`).then(({ data }) => data);

export const breIndustryRules = breRuleChange =>
  post(
    `breRules/conditions`,
    {
      breIndustryRuleList: [breRuleChange]
    },
    {
      'Content-Type': 'application/json'
    }
  ).then(({ data }) => data);

export const getIndustryBreRules = () =>
  get(`breRules/get/industry/rules`).then(({ data }) => data);

export const getCompanyNameByGst = (gstNo = '') =>
  get(`master/industry/gst/authentication?gstin=${gstNo}`).then(
    ({ data }) => data
  );
